import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyShippingPolicy = loadable(
  () =>
    import(
      /* webpackChunkName: "content/catalog/shippingpolicy" */
      '.'
    ),
);
